// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const torkoal: PokeData = {
  "id": 324,
  "name": "torkoal",
  "height": 5,
  "weight": 804,
  "base_experience": 165,
  "types": [
    PokeType.FIRE
  ],
  "api_moves": [
    "body-slam",
    "ember",
    "flamethrower",
    "fire-spin",
    "smokescreen",
    "withdraw",
    "smog",
    "amnesia",
    "flame-wheel",
    "curse",
    "flail",
    "protect",
    "rapid-spin",
    "heat-wave",
    "eruption",
    "iron-defense",
    "lava-plume",
    "clear-smog",
    "shell-smash",
    "inferno"
  ],
  "moves": [
    "body-slam",
    "ember",
    "flamethrower",
    "fire-spin",
    "curse",
    "protect",
    "eruption",
    "fire-fang",
    "flare-blitz",
    "magma-storm",
    "morning-sun",
    "sunny-day",
    "fire-punch"
  ],
  "evolution_chain": {
    "id": 163,
    "item": null,
    "species": [
      {
        "name": "torkoal",
        "order": 352,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 175,
    "speed": 40,
    "ability_power": 170
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
